import { render, staticRenderFns } from "./OncologyMedicalHistory.vue?vue&type=template&id=60a91d6a&scoped=true"
import script from "./OncologyMedicalHistory.vue?vue&type=script&lang=js"
export * from "./OncologyMedicalHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a91d6a",
  null
  
)

export default component.exports